import { HttpClient } from '@angular/common/http';
import { AuthApi } from './auth/api.auth';
import { TranslateApi } from './translate/api.translate';
import { ApiClientConfig } from './api-client.config';
import { UserApi } from './user/api.user';

export class ApiClient {
    readonly auth: AuthApi;
    readonly translate: TranslateApi;
    readonly user: UserApi;

    constructor(private http: HttpClient, config: ApiClientConfig) {
        this.auth = new AuthApi(this.http, config);
        this.translate = new TranslateApi(this.http, config);
        this.user = new UserApi(this.http, config);
    }
}
